import type { Provenance } from "./contract";
import * as commun from "./sauvegarde-texte";

/**
 * La sauvegarde automatique du texte d'une double (maquette `HistoiresEtats.dc.html`, « La
 * sauvegarde, pas à pas »). Le moteur est commun a la console depuis #276
 * (`sauvegarde-texte.ts`, ou tout son comportement est decrit) : ce fichier le pose aux mots
 * des Histoires, ou « qui a ecrit » est la provenance d'une double.
 */

export { DELAI_SAUVEGARDE_MS, NOUVEL_ESSAI_MS } from "./sauvegarde-texte";

export type EtatSauvegarde = commun.EtatSauvegarde<Provenance>;
export type Instantane = commun.Instantane<Provenance>;
export type Dependances = commun.Dependances<Provenance>;
export type Moteur = commun.Moteur<Provenance>;

export const creerMoteur = commun.creerMoteur<Provenance>;
